import * as THREE from 'three';
import { getTableLayout, ballRadius } from '../sim/world.js';
import { railOuterX, railOuterY, railBottomZ } from './table-rails.js';

/**
 * テーブル本体（キャビネット）の木製側面（自前・GPL非依存）。
 *
 * vendor のクロススラブは厚い緑のボックスで、その側面が「緑の台」として露出して
 * 不自然だった。本モジュールはレール外周 footprint の木製パネル4枚を、レール下端
 * (z=railBottomZ) から床まで配置し、緑のスラブ側面を覆って木製キャビネットに見せる。
 *
 * 物理・テーブル寸法には影響しない（純粋に視覚）。
 */

// キャビネットの深さ（レール下端からの高さ）。vendor スラブ底（約 -21R）を十分覆う。
const CABINET_DEPTH = ballRadius * 22;
const PANEL_THICKNESS = ballRadius * 1.2;

const WOOD_MAT = new THREE.MeshStandardMaterial({
  color: 0x2a1812,
  roughness: 0.6,
  metalness: 0.04,
  envMapIntensity: 0.4,
});

export const addTableCabinet = (scene: THREE.Scene): void => {
  try {
    const { halfX, halfY } = getTableLayout();
    const outX = railOuterX(halfX);
    const outY = railOuterY(halfY);
    const top = railBottomZ(); // レール下端 = キャビネット上端
    const centerZ = top - CABINET_DEPTH / 2;
    const t = PANEL_THICKNESS;

    const addPanel = (
      w: number,
      h: number,
      x: number,
      y: number,
    ): void => {
      const geo = new THREE.BoxGeometry(w, h, CABINET_DEPTH);
      const mesh = new THREE.Mesh(geo, WOOD_MAT);
      mesh.position.set(x, y, centerZ);
      mesh.castShadow = true;
      mesh.receiveShadow = true;
      scene.add(mesh);
    };

    // 東西パネル（x=±outX、内側へ厚み）。長辺方向は角まで覆うため 2*outY。
    addPanel(t, 2 * outY, outX - t / 2, 0);
    addPanel(t, 2 * outY, -(outX - t / 2), 0);
    // 南北パネル（y=±outY）。
    addPanel(2 * outX, t, 0, outY - t / 2);
    addPanel(2 * outX, t, 0, -(outY - t / 2));
  } catch (err) {
    console.error('addTableCabinet failed:', err);
  }
};
